import React from "react";
import { useTranslation } from "react-i18next";

import {
  FaClipboardList,
  FaClock,
  FaGraduationCap,
  FaMapMarkerAlt,
  FaMoneyBill,
} from "react-icons/fa";

import JobDataTable from "./JobDataTable";

export const JobData = (props) => {
  const { t } = useTranslation();
  const { applyJobModalHandler, job } = props;

  const jobSpecifications = job && [
    {
      text: t("jobs.detail.location"),
      icon: <FaMapMarkerAlt />,
      data: job?.location,
    },
    {
      text: t("jobs.detail.requirements"),
      icon: <FaGraduationCap />,
      data: job?.requirements,
    },
    { text: t("jobs.detail.salary"), icon: <FaMoneyBill />, data: job?.salary },
    {
      text: t("jobs.detail.workPermit"),
      icon: <FaClipboardList />,
      data: job?.workPermit ? "✅" : "⛔",
    },
    { text: t("jobs.detail.hours"), icon: <FaClock />, data: job?.hours },
  ];

  return (
      <JobDataTable
        appliedAlready={props?.appliedAlready}
        modal={applyJobModalHandler}
        jobSpecifications={jobSpecifications}
      />
  );
};
